import { PROCESSING_PAYMENT_SLICE } from "./slice";

export const INIT_PROCESSING_PAYMENT_ACTION = `${PROCESSING_PAYMENT_SLICE}/initProcessingPayment` as const;
export const FINALIZE_PROCECCESSING_PAYMENT_ACTION = `${PROCESSING_PAYMENT_SLICE}/finalizeProcessingPayment` as const;